"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var js_joda_1 = require("js-joda");
var random = require("./random");
var century = require("./century");
var df = js_joda_1.DateTimeFormatter.ofPattern('ddMMyy');
var Groups;
(function (Groups) {
    Groups[Groups["day"] = 1] = "day";
    Groups[Groups["month"] = 2] = "month";
    Groups[Groups["year"] = 3] = "year";
})(Groups || (Groups = {}));
var Bday = /** @class */ (function () {
    function Bday(value) {
        var _this = this;
        this.value = value;
        this.toString = function () { return _this.value.format(df); };
        this.toCenturyId = function () { return century.parse(Bday.toCentury(_this.value)); };
    }
    Bday.parse = function (s, centuryId) {
        var m = s.match(Bday.re);
        if (m == null) {
            throw new Error('Invalid bday: pattern mismatch');
        }
        var day = parseInt(m[Groups.day], 10);
        var month = parseInt(m[Groups.month], 10);
        var year = parseInt(m[Groups.year], 10) + centuryId.century();
        return new Bday(js_joda_1.LocalDate.of(year, month, day));
    };
    Bday.from = function (date) { return new Bday(date); };
    // NOTE: min and max are only approximations here as UTC is used
    Bday.random = function (minAge, maxAge) {
        if (minAge === void 0) { minAge = 16; }
        if (maxAge === void 0) { maxAge = 117; }
        var start = js_joda_1.LocalDate.now().minusYears(maxAge).atStartOfDay(js_joda_1.ZoneId.UTC).toInstant().toEpochMilli();
        var end = js_joda_1.LocalDate.now().minusYears(minAge).atStartOfDay(js_joda_1.ZoneId.UTC).toInstant().toEpochMilli();
        return js_joda_1.LocalDate.ofInstant(js_joda_1.Instant.ofEpochMilli(random.fromRange(start, end)));
    };
    Bday.pattern = '^' + // start
        '(\\d{2})' + // dd
        '(\\d{2})' + // MM
        '(\\d{2})' + // yy
        '$'; // end
    Bday.re = new RegExp(Bday.pattern);
    Bday.toCentury = function (date) { return Math.floor((date.year() / 100)) * 100; };
    return Bday;
}());
exports.Bday = Bday;
//# sourceMappingURL=bday.js.map